import { styled, useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { ResponsiveBar } from '@nivo/bar';
import './charts.css';
import Scrollbar from 'components/Scrollbar';
import { CSSProperties } from 'react';
import { kFormatter } from 'utils/formatNumber';

type BarChartProps = {
  data: {
    month: string; earnings: number 
}[];
  sx?: CSSProperties;
  ChartSx?: CSSProperties;
};



export default function BarChart({ data = [], sx = {}, ChartSx = {} }: BarChartProps) {
  const getMax = [...data];
  const max = getMax?.length > 0
  ? getMax?.sort((a, b) => b?.earnings - a?.earnings)[0]?.earnings
  : 50
  const ticksValue = max > 30 && max <120 ? [0,20,40,60,80] : max > 120 ? [0,30,60,90,120] : [0,10,20,30]
  
  const theme = useTheme();

  const ToolTip = styled('div')(({ theme }) => ({
    backgroundColor: '#fff',
    padding: '5px 10px',
    border: '1px solid #DFE3E8',
    fontSize: '12px',
    borderRadius: '5px',
    direction: theme.direction
  }));
  return (
    <Box
      sx={{
        direction: 'rtl'
      }}
    >
      <Scrollbar
        sx={{
          width: '100%',
          overflowY: 'hidden',
          overflowX: 'auto'
        }}
        // @ts-ignore
        scrollStyles={{
          bar: {
            backgroundColor: '#d49e24'
          },
          track: {
            backgroundColor: '#F4F6F8'
          }
        }}
      >
        <Box sx={{ height: 200, minWidth: '500px', ...sx }}>
          <ResponsiveBar
            tooltip={(e) => <ToolTip>{`${kFormatter(e.data.earnings*1000)} SAR`}</ToolTip>}
            data={data}
            minValue={0}
            maxValue={max}
            keys={['earnings']}
            indexBy="month"
            margin={{ top: 50, right: 10, bottom: 40, left: 30 }}
            padding={0.25}
            defs={[
              {
                id: 'gradientC',
                type: 'linearGradient',
                colors: [
                  { offset: 0, color: '#d49e24' },
                  { offset: 100, color: '#dab65e' }
                ]
              }
            ]}
            fill={[
              {
                match: {
                  id: 'earnings'
                },
                id: 'gradientC'
              }
            ]}
            axisTop={null}
            axisRight={null}
            axisBottom={{
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: '',
              legendPosition: 'middle',
              legendOffset: 32
            }}
            gridYValues={5}
            axisLeft={{
              tickSize: 0,
              tickValues: ticksValue,
              renderTick: ({ value, x, y }) => {
                return (
                  <g transform={`translate(${x - 25},${y + 4})`}>
                    <text
                      style={{
                        fill: theme.palette.mode === 'dark'   ? 'white' : '#161C24',
                        fontSize: '12px',
                        marginRight: '10px'
                      }}
                    >
                      {value}k
                    </text>
                  </g>
                );
              },
              tickPadding: 40,
              tickRotation: 0,
              legend: ''
            }}
            enableLabel={false}
            labelSkipHeight={4}
            labelTextColor={{
              from: 'color',
              modifiers: [['darker', 1.6]]
            }}
            theme={{
              axis: {
                ticks: {
                  text: {
                    fill: theme.palette.mode === 'dark'   ? 'white' : '#161C24',
                    // Change this to your desired color
                  },
                },
              },
            }}
          />
        </Box>
      </Scrollbar>
    </Box>
  );
}
